import { apiClient } from './api.client'

/** Tenant locale settings (TO-415 tenant-locale-settings, consumed by TO-416). */
export interface LocaleSettingsDTO {
	enabledLocales: string[]
	requiredLocales: string[]
	defaultLocale: string | null
	updatedAt: string | null
}

export interface LocaleSettingsBody {
	enabledLocales: string[]
	requiredLocales: string[]
	defaultLocale: string
}

const path = (slug: string) => `/t/${encodeURIComponent(slug)}/admin/settings/locale`

export const localeSettingsService = {
	get: async (slug: string) => (await apiClient.get<LocaleSettingsDTO>(path(slug))).data,
	save: async (slug: string, body: LocaleSettingsBody) =>
		(await apiClient.put<LocaleSettingsDTO>(path(slug), body)).data,
}
